// extracted by mini-css-extract-plugin
export default {"subHeaderContainer":"k6WkYLtC","pill":"Mqj4ELc8","smallPill":"NVtK7xsb","title":"RGWvN00q","smallTitle":"_qdQWzII"};